import { createSlice } from '@reduxjs/toolkit';

const usersSlice = createSlice({
    name: 'users',
    initialState: {
        usersList: null,
        actualUser: null,
    },
    reducers: {
        setUsersList: (state, action) => {
            state.usersList = action.payload;
        },
        addUser: (state, action) => {
            state.usersList = [...state.usersList, action.payload];
        },
        deleteUserAction: (state, action) => {
            state.usersList = state.usersList.filter(user => user.username !== action.payload);
        },
        setActualUser: (state, action) => {
            state.actualUser = action.payload;
        }
    }
})

export const { setUsersList, addUser, deleteUserAction, setActualUser } = usersSlice.actions;

export default usersSlice.reducer;
